// old apiUrl: 'http://ec2-18-219-69-192.us-east-2.compute.amazonaws.com:3000',

const config = {
  development: {
    apiUrl: 'http://localhost:3000',
    s3Bucket: 'cjp-photo-bucket',
    awsRegion: 'us-east-1'
  },
  production: {
    // apiUrl: 'https://ec2-18-219-69-192.us-east-2.compute.amazonaws.com:3000',
    apiUrl: 'https://api.studiogo.photo',
    s3Bucket: 'cjp-photo-bucket',
    awsRegion: 'us-east-1'
  }
};

// Force production mode for now
const env = 'production';

export const API_BASE_URL = config[env].apiUrl;
export const S3_BUCKET = config[env].s3Bucket;
export const AWS_REGION = config[env].awsRegion; 